export default __webpack_public_path__ + "images/0xf0f14634971c43d872d1cf1785195c0ce1000a9d.png";